/* ==========================================================================
   Markus Upgraded (draft), Option B: collection page behaviors (blueprint U-F3, U-F4, U-F6).
   Instant filters, sort, per page, pagination and Load more go through the Section Rendering
   API (?section_id=up-collection) and swap the results region in place. Every path falls back
   to a normal full navigation when the fetch fails or the markup is missing, and the page works
   without JS (native GET forms, real links). Vanilla, ES2018, no dependencies. Loaded deferred
   after assets/upgrade.js so window.UpDrawers is available.
   ========================================================================== */
(function () {
  'use strict';
  var SECTION_ID = 'up-collection';
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function announce(text) {
    var live = qs('[data-up-cart-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }
  function root() { return qs('[data-up-collection]'); }
  function headerOffset() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--up-header-h'), 10);
    return (isNaN(v) ? 72 : v) + 16;
  }
  function cleanUrl(u) { u.searchParams.delete('section_id'); u.searchParams.delete('sections'); return u; }

  var controller = null;
  function fetchSection(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', SECTION_ID);
    if (controller && controller.abort) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    return fetch(u.toString(), { signal: controller ? controller.signal : undefined, headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }
  function setLoading(on) {
    var res = qs('[data-up-results]', root());
    if (!res) return;
    res.classList.toggle('is-loading', on);
    res.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* swap results + refresh the facets (counts, active states) from a fetched section document */
  function swap(doc) {
    var r = root();
    var newResults = qs('[data-up-results]', doc), curResults = qs('[data-up-results]', r);
    if (!newResults || !curResults) return false;
    curResults.innerHTML = newResults.innerHTML;
    var newBody = qs('[data-up-facets-body]', doc), curBody = qs('[data-up-facets-body]', r);
    if (newBody && curBody) {
      var active = document.activeElement, keepName = null, keepVal = null, keepPos = null;
      if (active && curBody.contains(active) && /^(number|text)$/.test(active.type || '')) { keepName = active.name; keepVal = active.value; try { keepPos = active.selectionStart; } catch (e) { keepPos = null; } }
      curBody.innerHTML = newBody.innerHTML;
      if (keepName) {
        var again = qsa('input', curBody).filter(function (i) { return i.name === keepName; })[0];
        if (again) { again.value = keepVal; again.focus({ preventScroll: true }); if (keepPos !== null) { try { again.setSelectionRange(keepPos, keepPos); } catch (e) { /* number inputs refuse */ } } }
      }
    }
    var newCount = qs('[data-up-facets-count]', doc);
    if (newCount) qsa('[data-up-facets-count]', r).forEach(function (el) { el.textContent = newCount.textContent; });
    var newForm = qs('[data-up-facets-form]', doc), curForm = qs('[data-up-facets-form]', r);
    if (newForm && curForm) {
      curForm.classList.toggle('has-active', newForm.classList.contains('has-active'));
      var newClear = qs('[data-up-filter-clear]', newForm), curClear = qs('.up-facets-foot [data-up-filter-clear]', curForm);
      if (newClear && curClear) curClear.setAttribute('href', newClear.getAttribute('href'));
    }
    var newTitleCount = qs('[data-up-drawer-filter-count]', doc), curTitleCount = qs('[data-up-drawer-filter-count]', r);
    if (curTitleCount) curTitleCount.textContent = newTitleCount ? newTitleCount.textContent : '';
    return true;
  }

  function load(url, opts) {
    opts = opts || {};
    var u = cleanUrl(new URL(url, window.location.origin));
    setLoading(true);
    return fetchSection(u.toString()).then(function (doc) {
      if (!swap(doc)) { window.location.href = u.toString(); return; }
      if (opts.push !== false) history.pushState({ upCollection: true }, '', u.toString());
      setLoading(false);
      if (opts.scroll) {
        var top = qs('[data-up-results]', root());
        if (top) { var y = top.getBoundingClientRect().top + window.pageYOffset - headerOffset(); window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); }
      }
      var count = qs('[data-up-results-count]', root());
      announce(count ? count.textContent.trim() : 'Results updated');
      document.dispatchEvent(new CustomEvent('up:section:loaded', { detail: { root: root() } }));
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      setLoading(false);
      window.location.href = u.toString();
    });
  }

  /* facets form -> URL (drops empty params, keeps sort_by / view) */
  function facetsUrl() {
    var form = qs('[data-up-facets-form]', root());
    if (!form) return null;
    var u = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    var raw = new URLSearchParams(new FormData(form));
    var cleaned = new URLSearchParams();
    raw.forEach(function (v, k) { if (v !== '') cleaned.append(k, v); });
    var cur = new URL(window.location.href);
    if (cur.searchParams.get('sort_by') && !cleaned.has('sort_by')) cleaned.set('sort_by', cur.searchParams.get('sort_by'));
    if (cur.searchParams.get('view') && !cleaned.has('view')) cleaned.set('view', cur.searchParams.get('view'));
    u.search = cleaned.toString();
    return u;
  }
  function isInstant() { var r = root(); return !!r && r.getAttribute('data-up-instant') !== 'false'; }
  function defaultPer() { var r = root(); return r ? (r.getAttribute('data-up-default-per') || '24') : '24'; }

  var applyFacets = function () { var u = facetsUrl(); if (u) load(u.toString(), { push: true }); };
  var applyFacetsDebounced = debounce(applyFacets, 500);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!root() || !root().contains(t)) return;
    if (t.closest('[data-up-facets-form]')) {
      if (!isInstant()) return;
      if (t.type === 'checkbox' || t.type === 'radio' || t.tagName === 'SELECT') applyFacets();
      return;
    }
    if (t.matches('[data-up-sort]')) {
      var s = new URL(window.location.href);
      s.searchParams.set('sort_by', t.value);
      s.searchParams.delete('page');
      load(s.toString(), { push: true });
      return;
    }
    if (t.matches('[data-up-per-page]')) {
      var p = new URL(window.location.href);
      if (t.value === '' || t.value === 'per-' + defaultPer()) p.searchParams.delete('view'); else p.searchParams.set('view', t.value);
      p.searchParams.delete('page');
      load(p.toString(), { push: true });
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!root() || !isInstant() || !t.closest('[data-up-facets-form]')) return;
    if (t.type === 'number' || t.type === 'text') applyFacetsDebounced();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!root() || !root().contains(f)) return;
    if (f.matches('[data-up-facets-form]')) {
      e.preventDefault();
      applyFacets();
      if (window.UpDrawers && window.UpDrawers.isOpen && window.UpDrawers.isOpen()) window.UpDrawers.close();
      return;
    }
    if (f.matches('[data-up-toolbar-form]')) {
      e.preventDefault();
      var u = new URL(f.getAttribute('action') || window.location.pathname, window.location.origin);
      var raw = new URLSearchParams(new FormData(f)), cleaned = new URLSearchParams();
      raw.forEach(function (v, k) { if (v !== '' && !(k === 'view' && v === 'per-' + defaultPer())) cleaned.append(k, v); });
      u.search = cleaned.toString();
      load(u.toString(), { push: true });
    }
  });
  /* active pill removal, clear all, numbered pagination */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('[data-up-filter-remove], [data-up-filter-clear], [data-up-page-link]');
    if (!a || !root() || !root().contains(a)) return;
    var href = a.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    load(href, { push: true, scroll: a.hasAttribute('data-up-page-link') });
  });
  /* load more: append the next page's cards, keep the URL honest */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-up-load-more]');
    if (!b || !root() || !root().contains(b)) return;
    e.preventDefault();
    var next = b.getAttribute('href');
    if (!next) return;
    b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');
    fetchSection(next).then(function (doc) {
      var r = root();
      var newGrid = qs('[data-up-grid]', doc), curGrid = qs('[data-up-grid]', r);
      var newPag = qs('[data-up-pagination]', doc), curPag = qs('[data-up-pagination]', r);
      if (!newGrid || !curGrid) { window.location.href = next; return; }
      var added = 0, firstNew = null;
      qsa(':scope > *', newGrid).forEach(function (el) {
        var node = document.importNode(el, true);
        if (!firstNew) firstNew = node;
        curGrid.appendChild(node); added++;
      });
      if (curPag) curPag.innerHTML = newPag ? newPag.innerHTML : '';
      var count = qs('[data-up-results-count]', r);
      if (count && count.getAttribute('data-up-from')) {
        var from = parseInt(count.getAttribute('data-up-from'), 10) || 1;
        var total = count.getAttribute('data-up-total') || '';
        count.textContent = 'Showing ' + from + ' to ' + (from - 1 + curGrid.children.length) + (total ? ' of ' + total : '');
      }
      var u = cleanUrl(new URL(next, window.location.origin));
      history.replaceState({ upCollection: true }, '', u.toString());
      if (firstNew && firstNew.focus) {
        firstNew.setAttribute('tabindex', '-1');
        firstNew.focus({ preventScroll: true });
        firstNew.addEventListener('blur', function onBlur() { firstNew.removeAttribute('tabindex'); firstNew.removeEventListener('blur', onBlur); });
      }
      announce('Loaded ' + added + ' more products');
      document.dispatchEvent(new CustomEvent('up:section:loaded', { detail: { root: curGrid } }));
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      window.location.href = next;
    });
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.upCollection && root()) load(window.location.href, { push: false });
  });
})();
